const getTimeParts = (timeInSeconds: number) => ({
  hours: Math.floor(timeInSeconds / 3600),
  minutes: Math.floor((timeInSeconds % 3600) / 60),
  seconds: Math.floor(timeInSeconds) % 60,
});

const pad = (num: number) => {
  return String(num).padStart(2, '0');
};

const getCountWithLabel = (count: number, singularLabel: string, pluralLabel: string) =>
  `${count} ${count === 1 ? singularLabel : pluralLabel}`;

export const formatTime = (timeInSeconds: number) => {
  const { hours, minutes, seconds } = getTimeParts(Math.abs(timeInSeconds));

  const parts = [pad(minutes), pad(seconds)];

  if (hours > 0) {
    parts.unshift(hours.toString());
  }

  const sign = timeInSeconds < 0 ? '-' : '';

  return sign + parts.join(':');
};

export const getTimeLabel = (timeInSeconds: number) => {
  const { hours, minutes, seconds } = getTimeParts(Math.abs(timeInSeconds));
  const parts = [getCountWithLabel(seconds, 'Sekunde', 'Sekunden')];

  if (minutes > 0 || hours > 0) {
    parts.unshift(getCountWithLabel(minutes, 'Minute', 'Minuten'));
  }
  if (hours > 0) {
    parts.unshift(getCountWithLabel(hours, 'Stunde', 'Stunden'));
  }

  const sign = timeInSeconds < 0 ? '-' : '';

  return sign + parts.join(' ');
};
